<template>
    <!-- 处理PDF格式文件，针对翻页 -->
    <div class="resourcePDF">
        <iframe :id="frameId" ref="docFrame" :src="docUrl" class="resourcePDFUrl" allowfullscreen="true"></iframe>
    </div>
</template>

<script>
export default {
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        
        currentShow: {
            type: String,
            default: ''
        },

        hwFilesData: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            componentId: null,
            docId: null,
            docUrl: null,
            supportedEventNames: ['resource.show','files.pageNext','files.pagePrev', 'files.pageGoto','common.moveJoystick'],
            resData: null,
            extName: null,
        };
    },

    computed: {
        frameId: function() {
            return this.componentId + '-frame';
        },

    },

    watch: {
        currentShow: function(val,oldVal) {
            if (val !== this.componentId && oldVal === this.componentId) {
                this.docId = null;
                this.docUrl = null;
                
            };
        }
    },

    created: function() {
        if (this.isLock) return;
        if (this.currentShow === 'hw-1') {
            let data = this.hwFilesData.data;
            data.id = this.hwFilesData.data.relationId;
            console.log(data);
            this.$nextTick(() => {
                this.showDocument(data);
            });
            
        }
    },
    
    mounted: function() {
        this.componentId = this.$attrs.id;

        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },
    
    methods: {
        windowMessageHandler: function(e) {
            let msg = e.data;
            if (! msg.eventName || this.supportedEventNames.indexOf(msg.eventName) === -1) return;
            // 锁定状态下当前层不接受响应
            if (this.isLock && (this.currentShow === this.componentId || this.componentId === 'hw-pdf')) return;
            // console.log(this.isLock,this.componentId)
            if (!this.isLock && this.currentShow !== this.componentId && this.componentId !== 'hw-pdf') return;
            let resData = msg.data;
            
            let iframes = document.querySelector('#' + this.frameId);
            
            switch (msg.eventName) {
                case 'resource.show':
                    if (resData.mimeType === 'mosoink/url') return;
                    if (resData.mimeType !== 'mosoink/url' && ! resData.previewableDocument) return;
                    // if (!this.isLock && this.currentShow !== this.componentId) return;
                    if (this.docId === resData.id) return;
                    this.showDocument(resData);
                    // console.log(this.currentShow,this.componentId,this.docId);
                    break;
                case 'files.pageNext':
                    // console.log(this.currentShow,this.componentId);
                    // if (!this.isLock && this.currentShow !== this.componentId) return;
                    if (this.isLock && this.currentShow === this.componentId) return;
                    if (resData.id != this.docId) return;
                    iframes.contentWindow.postMessage('{"action": "ppt.slide.next"}',this.docUrl);
                    break;
                case 'files.pagePrev':
                    // if (!this.isLock && this.currentShow !== this.componentId) return;
                    if (this.isLock && this.currentShow === this.componentId) return;
                    if (resData.id != this.docId) return;

                    iframes.contentWindow.postMessage('{"action": "ppt.slide.prev"}',this.docUrl);
                    break;
                case 'files.pageGoto':
                    let event = {
                        action: 'ppt.slide.goto',
                        data: {
                            pagenum: resData.pageNum
                        }
                    };
                    iframes.contentWindow.postMessage(JSON.stringify(event),this.docUrl);
                    break;
                case 'common.moveJoystick':
                    if (this.isLock && this.currentShow === this.componentId) return;
                    // if (resData.id !== this.docId) return;
                    let direction = resData.direction;
                    if (this.extName === '.pdf') {
                        iframes.contentWindow.postMessage(this.json2str({action: 'pdf.page.scroll' , data: {
                                direction: direction,
                                offset: '40'
                            }
                        }), '*');
                        return;
                    };
                    iframes.contentWindow.postMessage(this.json2str({ action: 'word.page.scroll' , data: {
                            direction: direction,
                            offset: '40'
                        }
                    }), '*');
                    break;
            }

        },

        showDocument: function(resData) {
            this.docId = resData.id;

            let url = null;
            if (resData.mimeType === 'mosoink/url') {
                url = resData.content;
            } else if (resData.previewableDocument) {
                url = resData.url;
            }
            
            if (! url) {
                //TODO: show "can not preview document"
                return;
            }

            this.docUrl = url;
            this.extName = resData.extName;
        },

        json2str: function(obj) {
            return JSON.stringify(obj, function(key, val) {
                if (typeof val === 'function') {
                    val = val.toString();
                }
                return val;
            });
        },

    },
};
</script>

<style>
    .resourcePDF {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        overflow: hidden;
    }
    
    .resourcePDFUrl {
        border: none;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        background: #ffffff;
    }
</style>